import { useState, useCallback } from "react";
import { useTranslation } from 'react-i18next';
import { useGetApplications } from "@/hooks";
import ApplicationsList from "@/components/applications/applications-list";

const ProcessedApplicationsPage = () => {
  const { t } = useTranslation();
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");

  const { data: responseData, isLoading, isError } = useGetApplications(
    'processed',
    false,
    { page, limit: 20, search: search || undefined }
  );

  const data = responseData?.data || [];
  const meta = responseData?.meta;

  const handleSearchChange = useCallback((s: string) => {
    setSearch(s);
    setPage(1);
  }, []);

  return (
    <ApplicationsList
      data={data}
      isLoading={isLoading}
      isError={isError}
      title={t('processManagement.processedApplications')}
      loadingMessage={t('processManagement.loading')}
      errorMessage={t('processManagement.anErrorOccurredWhileFetchingProcessedApplications')}
      searchPlaceholder={t('processManagement.search')}
      baseRoute="/staff/incoming/processed-applications"
      noDataMessage={t('processManagement.noProcessedApplicationsFound')}
      meta={meta}
      search={search}
      onSearchChange={handleSearchChange}
      onPageChange={setPage}
    />
  );
};

export default ProcessedApplicationsPage;